module.exports = __webpack_public_path__ + "assets/lessons/pl/lesson4/modals/lesson_4_5_c.pdf";